{
  "UPLOADER": {
    "NEW_IMPORT": "New Import",
    "IMPORT_FINISHED": "Import finished",
    "ERROR_SENDING_TASK": "Error sending task to background",
    "IMPORT_BACKGROUND": "Import background",
    "IMPORT_XML": "Import",
    "IMPORT_LIST": "Import list"
  }
}